import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const variantPalette = (theme, variant) => {
  switch (variant) {
    case 'success':
      return {
        bgcolor: theme.palette.success.main,
        color: theme.palette.success.contrastText,
      };
    case 'error':
      return {
        bgcolor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
      };
    case 'warning':
      return {
        bgcolor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText,
      };
    case 'info':
      return {
        bgcolor: theme.palette.info.main,
        color: theme.palette.info.contrastText,
      };
    default:
      return {
        bgcolor: theme.palette.grey[900],
        color: theme.palette.common.white,
      };
  }
};

export const BennieSnackbarContent = forwardRef(function BennieSnackbarContent(
  props,
  ref,
) {
  const {
    id,
    message,
    action: componentOrFunctionAction,
    variant = 'default',
    style,
    className,
  } = props;

  const actionNode =
    typeof componentOrFunctionAction === 'function'
      ? componentOrFunctionAction(id)
      : componentOrFunctionAction;

  return (
    <Box
      ref={ref}
      role="alert"
      aria-describedby="notistack-snackbar"
      className={className}
      style={style}
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        padding: '6px 16px',
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[3],
        minWidth: 288,
        maxWidth: 568,
        position: 'relative',
        ...variantPalette(theme, variant),
      })}
    >
      <Typography
        component="div"
        id="notistack-snackbar"
        sx={{
          flex: '1 1 auto',
          py: 1,
          pr: '25px',
          mr: 0,
          wordBreak: 'break-word',
          color: 'inherit',
        }}
      >
        {message}
      </Typography>
      {actionNode ? (
        <Box
          sx={{
            position: 'absolute',
            right: 10,
            top: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
            paddingLeft: 2,
          }}
        >
          {actionNode}
        </Box>
      ) : null}
    </Box>
  );
});

BennieSnackbarContent.displayName = 'BennieSnackbarContent';

BennieSnackbarContent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  message: PropTypes.node,
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  variant: PropTypes.oneOf(['default', 'success', 'error', 'warning', 'info']),
  style: PropTypes.object,
  className: PropTypes.string,
};
